import AddressForm from '../../AddressForm';
import KycForm from '@/components/Tests/kycForm';
import moment from 'moment';
import YuriDatePicker from '@/components/YuriDatePicker';
import ShowPasswordInput from '@/components/ShowPasswordInput';
import { canRoles, mappingRoles } from '../Interveners/roles_logic';
import { sha3_512 } from 'js-sha3';
import UsersService from '@/services/users.service';
import documentsService from '@/services/documents.service';
import roles from '@/utils/roles';
import tests from '@/utils/tests';

export default {
    name: 'IntervenerCreateForm',

    props: {
        uuidAccount: {
            type: String,
            required: true
        },
        roles: {
            type: Array,
            required: true
        },
        intervenersList: {
            type: Array,
            required: true
        },
        accountType: {
            type: String,
            required: true
        },
        intervenerAddType: {
            type: String,
            required: true
        },
        account: {
            type: Object,
            required: true
        }
    },

    components: {
        AddressForm,
        KycForm,
        ShowPasswordInput,
        YuriDatePicker
    },

    //TODO Dividir en componentes si es la funcionalidad que el cliente espera
    data() {
        return {
            // Interveners list to check if new intervener already exists
            interveners: [],
            // Switch to reuse component
            isLoading: false,
            showLogin: true,
            loginStep: 1,
            logedIntervenerData: {},
            loggedIntervenerPendingOTP: null,
            // Existing intervener login
            existingIntervenerLogin: {},
            // New intervener data
            account_intervener_role: [],
            personalData: {
                // Solo se pueden añadir físicas
                intervener_type: 'F'
            },
            contactData: {},
            fiscalAddress: {},
            postalAddress: {},
            mailingType: 'EMAIL',
            addPostalAddress: false,
            // Configuration fields options
            // Personal data
            countriesOptions: [],
            dateMaxAge: '',
            dateMinAge: '',
            maritalStatusesOptions: [],
            isAddingSecondaryIntervener: false,
            comunicationType: 'EMAIL',
            genderOptions: [
                { text: 'Hombre', value: 'V' },
                { text: 'Mujer', value: 'H' }
            ],
            documentTypeOptions: [
                { name: 'NIE', key: 'NIE' },
                { name: 'DNI', key: 'DNI' },
                { name: 'Pasaporte', key: 'PASAPORTE' }
            ],
            // Addressy
            provincesOptions: [],
            selectedAddress: '',
            keyUpdate: 0,
            otpActive: false,
            //Document upload
            selectedFrontFile: null,
            selectedBackFile: null,
            juridicalRepresentativeFile: null,
            showInvalidDocumentSize: false,
            showInvalidDocumentFormat: false,
            acceptedFormats: '.pdf,.doc,.docx,.jpg,.jpeg,.png',
            maxSizeInBytes: 10000000,
            intervenersOTP: [],
            needFatcaCrs: false,
            needKYC: false,
            otpVerification: null
        };
    },

    created() {
        this.interveners = this.intervenersList
            ? JSON.parse(JSON.stringify(this.intervenersList))
            : [];

        this.setMinMaxBirthdate();
        this.loadMaritalStatusOptions();
        this.loadCountriesOptions();
        if (this.account && !this.account.draft_data) this.account.draft_data = {};
    },

    mounted() {
        this.$root.$on('dismiss', () => (this.otpActive = false));
        this.$root.$on('close-otp-modal', () => (this.otpActive = false));
    },

    beforeDestroy() {
        this.$root.$off('dismiss');
        this.$root.$off('close-otp-modal');
    },

    watch: {
        'personalData.document_type': function () {
            this.needsReversoDocument;
            this.isOptionalDocument;
        },

        account_intervener_role: async function () {
            await this.checkNeedTests();
        },

        'personalData.birthdate': async function () {
            await this.checkNeedTests();
        }
    },

    methods: {
        isIntervenerDuplicate(documentId) {
            const isActiveIntervener = this.interveners.some(
                intervener => intervener.document_id === documentId
            );
            const draftData = this.account.draft_data || {};
            const isPendingInDraft =
                `registered_intervener_${documentId}` in draftData ||
                `new_intervener_${documentId}` in draftData;

            return isActiveIntervener || isPendingInDraft;
        },

        resetLogin() {
            this.logedIntervenerData = {};
            this.account_intervener_role = [];
            this.personalData = {
                intervener_type: 'F'
            };
            this.contactData = {};
            this.loginStep = 1;
            this.intervenersOTP = [];
        },

        handleLogin() {
            this.isLoading = true;
            this.$userService
                .login({
                    username: this.existingIntervenerLogin.username,
                    password: sha3_512(this.existingIntervenerLogin.password)
                })
                .then(response => {
                    const isIntervenerAlreadyAdded = this.isIntervenerDuplicate(
                        response.data.intervener.document_id
                    );
                    if (isIntervenerAlreadyAdded) {
                        this.$bvToast.toast(
                            'Este usuario ya se encuentra entre los intervinientes de la cuenta',
                            {
                                title: 'Error',
                                autoHideDelay: 10000,
                                variant: 'danger'
                            }
                        );
                        return;
                    }

                    const isMinor = moment().diff(response.data.intervener.birthdate, 'years') < 18;
                    if (isMinor) {
                        this.$bvToast.toast(
                            'No se puede añadir un interviniente menor de edad a una cuenta ya existente',
                            {
                                title: 'Error',
                                autoHideDelay: 10000,
                                variant: 'danger'
                            }
                        );
                        return;
                    }

                    this.loggedIntervenerPendingOTP = response.data.intervener;

                    this.activateOTPForLoggedIntervener();
                })
                .catch(err => {
                    console.error(err);
                    this.$bvToast.toast('Usuario o contraseña incorrectos', {
                        title: 'Error',
                        autoHideDelay: 10000,
                        variant: 'danger'
                    });
                })
                .finally(() => (this.isLoading = false));
        },

        confirmLoggedIntervener() {
            this.logedIntervenerData = { ...this.loggedIntervenerPendingOTP };
            this.loggedIntervenerPendingOTP = null;
            this.personalData.birthdate = this.logedIntervenerData.birthdate;
            this.loginStep++;
        },

        createLogedIntervener() {
            if (this.isIntervenerDuplicate(this.logedIntervenerData.document_id)) {
                this.$bvToast.toast(
                    'Este usuario ya se encuentra entre los intervinientes de la cuenta',
                    {
                        title: 'Error',
                        autoHideDelay: 10000,
                        variant: 'danger'
                    }
                );
                return;
            }

            this.isLoading = true;

            const formattedLoginIntervener = this.logedIntervenerData;
            formattedLoginIntervener.account_relationship = {
                account_intervener_role: this.account_intervener_role.length
                    ? this.account_intervener_role.map(role => role.key)
                    : null,
                mailing_type: formattedLoginIntervener.mailing_type
            };

            formattedLoginIntervener.representative_order = this.representativeOrder;

            formattedLoginIntervener.is_new_intervener = false;
            formattedLoginIntervener.personal_data = {
                class: formattedLoginIntervener.class
            };
            const body = {
                interveners: [formattedLoginIntervener],
                otp_verification: this.otpVerification
            };

            this.$accountService
                .insertAccountIntervener({}, body, this.uuidAccount)
                .then(() => {
                    this.$store.dispatch('resetDocumentItems');
                    this.resetLogin();
                    this.$emit('updateFromInterverCreation');
                })
                .catch(err => {
                    this.$bvToast.toast(`${err.message}`, {
                        title: 'Error',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 10000,
                        variant: 'danger'
                    });
                    console.error(err);
                })
                .finally(() => (this.isLoading = false));
        },

        async create() {
            if (this.isIntervenerDuplicate(this.personalData.document_id)) {
                this.$bvToast.toast(
                    'Este usuario ya se encuentra entre los intervinientes de la cuenta',
                    {
                        title: 'Error',
                        autoHideDelay: 10000,
                        variant: 'danger'
                    }
                );
                return;
            }

            this.isLoading = true;
            const newIntervener = await this.formatData();
            const body = {
                interveners: [newIntervener],
                otp_verification: this.otpVerification
            };

            this.$accountService
                .insertAccountIntervener({}, body, this.uuidAccount)
                .then(async response => {
                    const createdIntervener = this.getCreatedIntervener(response);
                    const createdIntervenerUuid = createdIntervener?.uuid;

                    if (this.selectedFrontFile) {
                        await this.uploadDocument(
                            this.selectedFrontFile,
                            'DOCUMENTO_IDENTIFICATIVO_PF_ANVERSO',
                            createdIntervenerUuid,
                            this.personalData.document_id
                        );
                    }

                    if (this.selectedBackFile) {
                        await this.uploadDocument(
                            this.selectedBackFile,
                            'DOCUMENTO_IDENTIFICATIVO_PF_REVERSO',
                            createdIntervenerUuid,
                            this.personalData.document_id
                        );
                    }

                    if (this.juridicalRepresentativeFile) {
                        await this.uploadDocument(
                            this.juridicalRepresentativeFile,
                            'ESCRITURAS_DE_PODERES',
                            this.juridicalIntervenerUuid,
                            this.juridicalIntervenerCif
                        );
                    }

                    this.$store.dispatch('resetDocumentItems');
                    this.resetLogin();
                    this.$emit('updateFromInterverCreation');
                })
                .catch(err => {
                    this.$bvToast.toast(`${err.message}`, {
                        title: 'Error',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 10000,
                        variant: 'danger'
                    });
                    console.error(err);
                })
                .finally(() => (this.isLoading = false));
        },

        changePassword(value) {
            this.existingIntervenerLogin.password = value;
        },

        loadMaritalStatusOptions() {
            const maritalStatuses = this.$t('maritalStatuses');
            this.maritalStatusesOptions = Object.entries(maritalStatuses).map(item => {
                return {
                    key: item[0],
                    name: item[1]
                };
            });
        },

        customPrefixCountry({ phone_prefix, name }) {
            return `${phone_prefix} — [${name}]`;
        },

        otpValidated(otpVerification) {
            this.otpVerification = otpVerification;
            this.showOTP = false;

            // Si tenemos loggegIntervenerPendingOTP, significa que se hizo el login y se pidio el otp
            // al interviniente logueado, para confirmar. Si metio el otp correctamente, se confirma los datos
            // para luego poder crear el interviniente logueado
            if (this.loggedIntervenerPendingOTP) {
                this.confirmLoggedIntervener();
            } else if (Object.keys(this.logedIntervenerData).length > 0) {
                this.createLogedIntervener();
            } else {
                this.create();
            }
        },

        activateOTP() {
            let intervener = undefined;
            if (Object.keys(this.logedIntervenerData).length > 0) {
                intervener = this.logedIntervenerData;
            } else {
                const formattedIntervener = this.formatData();
                intervener = formattedIntervener.personal_data;
            }
            const OTPData = {
                otp_type: 'ADD_INTERVENER',
                params: {
                    uuid_account: this.uuidAccount,
                    uuid_intervener: intervener && intervener.uuid ? intervener.uuid : undefined
                }
            };

            this.getIntervenersOTP();
            this.$store.dispatch('setOTPData', OTPData);
            this.otpActive = true;
        },

        activateOTPForLoggedIntervener() {
            // Si no tiene configurado el doble factor, simplemente confirmamos al interviniente añadido
            if (!this.loggedIntervenerPendingOTP.has_enable_two_factor_auth) {
                this.confirmLoggedIntervener();
                return null;
            }

            this.intervenersOTP = [this.loggedIntervenerPendingOTP];
            const OTPData = {
                otp_type: 'INTERVENER_ADDED_TO_ACCOUNT',
                params: {
                    uuid_account: this.uuidAccount
                }
            };

            this.$store.dispatch('setOTPData', OTPData);
            this.otpActive = true;
        },

        // TODO: unificar en un solo sitio la obtención de los paises
        // Esto está igual en ContactDataForm
        compareNames(a, b) {
            const nameA = a.name ? a.name.toUpperCase() : undefined;
            const nameB = b.name ? b.name.toUpperCase() : undefined;

            let comparison = 0;
            if (nameA > nameB) {
                comparison = 1;
            } else if (nameA < nameB) {
                comparison = -1;
            }
            return comparison;
        },

        async loadCountriesOptions() {
            this.countriesOptions = this.$store.getters['getCountriesOptions'];
        },

        // Set max min date of new intervener
        setMinMaxBirthdate() {
            const maxYears = 100;
            const minYears = 0;

            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const maxAge = new Date(today);
            maxAge.setFullYear(maxAge.getFullYear() - maxYears);
            this.dateMaxAge = maxAge;

            const minAge = new Date(today);
            minAge.setFullYear(minAge.getFullYear() - minYears);
            this.dateMinAge = minAge;
        },

        handleDocumentPermanent(isPermanent) {
            if (isPermanent) {
                this.document_date = '';
            }
            this.is_document_permanent = isPermanent;
        },

        // Format data to DB expected
        formatData() {
            const formattedNewIntervener = this.newIntervenerData;

            const kycTest = this.$refs.refKYCForm ? this.$refs.refKYCForm.formatTestsData() : {};
            formattedNewIntervener.tests = {
                ...kycTest
            };

            return formattedNewIntervener;
        },

        setFiscalAddresFromAutocomplete(newAddress) {
            this.fiscalAddress = newAddress;
        },

        setPostalAddresFromAutocomplete(newAddress) {
            this.postalAddress = newAddress;
        },

        selectedNationality(nationality) {
            this.personalData.document_type = null;
            this.personalData.document_id = null;
            if (nationality.key === 'ESP') {
                this.documentTypeOptions = [{ name: 'DNI', key: 'DNI' }];
            } else {
                this.documentTypeOptions = [
                    { name: 'NIE', key: 'NIE' },
                    { name: 'DNI', key: 'DNI' },
                    { name: 'Pasaporte', key: 'PASAPORTE' }
                ];
            }
        },

        replaceAddressApostrophes(address) {
            Object.keys(address).forEach(key => {
                if (typeof address[key] === 'string') {
                    address[key] = address[key].replace(/'/g, '`');
                }
            });
            return address;
        },
        onFileChange(file, documentType) {
            if (!file) return;

            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
            if (!this.acceptedFormats.split(',').includes(fileExtension)) {
                this.showInvalidDocumentFormat = true;
                return;
            } else {
                this.showInvalidDocumentFormat = false;
            }

            if (file.size > this.maxSizeInBytes) {
                this.showInvalidDocumentSize = true;
                return;
            } else {
                this.showInvalidDocumentSize = false;
            }

            if (documentType === 'front') {
                this.selectedFrontFile = file;
            } else if (documentType === 'back') {
                this.selectedBackFile = file;
            } else if (documentType === 'jurificalRepresentative') {
                this.juridicalRepresentativeFile = file;
            }
        },
        /**
         * The documents of the new intervener are uploaded after the intervener is created.
         * @param {*} documentType
         * @param {*} subcategory
         */
        getCreatedIntervener(response) {
            return response?.data?.interveners?.find(intervener => {
                const documentId =
                    intervener.document_id || intervener.personal_data?.document_id || null;

                return documentId === this.personalData.document_id;
            });
        },

        async uploadDocument(documentType, subcategory, uuidIntervener, filePrefix) {
            if (!uuidIntervener) {
                throw new Error('Error al subir el documento.');
            }

            const payload = {
                section: 'INTERVENER',
                files: [documentType],
                filesName: [`${filePrefix}_${subcategory}_${documentType.name}`],
                category: 'DOCUMENTATION',
                subcategory: subcategory,
                validated: false,
                uuid: uuidIntervener,
                uuid_account: this.uuidAccount
            };

            await documentsService.upload(payload);
        },

        async checkNeedTests() {
            if (!this.account_intervener_role.length) {
                this.needFatcaCrs = false;
                this.needKYC = false;

                return null;
            }

            const intervener = {
                ...this.personalData,
                roles: [...this.account_intervener_role]
            };

            const { needFatcaCrs, needKYC } = await tests.getEntityNeedKYCOrFatcaCrs(
                intervener,
                this.account
            );

            this.needFatcaCrs = needFatcaCrs;
            this.needKYC = needKYC;
        },

        async getIntervenersOTP() {
            this.intervenersOTP = [];
            const signatureTypesOTP = ['conjunta', 'mancomunada'];
            const intervenerRoleOTP = ['titular', 'nudo_propietario', 'apoderado', 'administrador'];
            const signatureType = this.account.signature_type.toLowerCase();

            if (signatureTypesOTP.includes(signatureType)) {
                this.intervenersList.filter(intervener => {
                    const intervenerRole = intervener.account_intervener_role[0].name.toLowerCase();

                    if (intervenerRoleOTP.includes(intervenerRole)) {
                        this.intervenersOTP.push(intervener);
                    }
                });
            } else {
                const userIntervener = UsersService.getIntervenerFromLocalStore();
                this.intervenersOTP.push(userIntervener);
            }

            if (this.intervenerAddType === 'PHYSICAL_ACCOUNT') {
                //Si es PHYSICAL_ACCOUNT se necesita la firma del intervener logeado o del nuevo interviniente para firmar la autorización a terceros
                if (Object.keys(this.logedIntervenerData).length > 0) {
                    this.intervenersOTP.push(this.logedIntervenerData);
                } else {
                    const newIntervener = this.formatData();
                    this.intervenersOTP.push(newIntervener);
                }
            } else {
                //Se comprueba que se ha llamado al OTP desde la creación de un nuevo intervener y no desde el login
                //para que se incluya al nuevo intervener en el OTP y así firme sus documentos
                if (Object.keys(this.logedIntervenerData).length === 0) {
                    const newIntervener = this.formatData();
                    this.intervenersOTP.push(newIntervener);
                }
            }
        }
    },

    computed: {
        newIntervenerData() {
            const formattedNewIntervener = {};
            this.fiscalAddress = this.replaceAddressApostrophes(this.fiscalAddress);

            formattedNewIntervener.personal_data = {
                name: this.personalData.name,
                lastname_1: this.personalData.lastname_1,
                lastname_2: this.personalData.lastname_2,
                intervener_type: 'F',
                birthdate: this.personalData.birthdate,
                document_expiration_date: this.personalData.document_expiration_date || null,
                document_type: this.personalData.document_type?.key,
                key_nationality_1: this.personalData.key_nationality_1?.key,
                key_nationality_2: null,
                key_country_of_birth: this.personalData.key_country_of_birth?.key,
                gender: this.personalData.gender,
                marital_status: this.personalData.marital_status?.key,
                matrimonial_regime: null,
                document_id: this.personalData.document_id
            };

            formattedNewIntervener.contacts = {
                email: this.contactData.email,
                key_mobile_phone_prefix: this.contactData.mobile_phone_prefix?.phone_prefix,
                mobile_phone: this.contactData.mobile_phone
            };

            formattedNewIntervener.fiscal_address = {
                f_address_key_country: this.fiscalAddress.country?.key,
                f_address_street_1: this.fiscalAddress.street_1,
                f_address_street_2: null,
                f_address_number: this.fiscalAddress.number,
                f_address_floor: this.fiscalAddress.floor,
                f_address_door: this.fiscalAddress.door,
                f_address_postal_code: this.fiscalAddress.postal_code,
                f_address_city: this.fiscalAddress.city,
                f_address_state: this.fiscalAddress.state?.name,
                f_address_key_state: this.fiscalAddress.state?.key
            };

            const localPostalAddress = this.addPostalAddress
                ? this.replaceAddressApostrophes(this.postalAddress)
                : this.fiscalAddress;
            formattedNewIntervener.postal_address = [
                {
                    key_country: localPostalAddress.country?.key,
                    street_1: localPostalAddress.street_1,
                    street_2: null,
                    number: localPostalAddress.number,
                    floor: localPostalAddress.floor,
                    door: localPostalAddress.door,
                    postal_code: localPostalAddress.postal_code,
                    city: localPostalAddress.city,
                    state: localPostalAddress.state?.name,
                    key_state: localPostalAddress.state?.key
                }
            ];

            formattedNewIntervener.business = {};
            formattedNewIntervener.account_relationship = {
                account_intervener_role: this.account_intervener_role.length
                    ? this.account_intervener_role.map(role => role.key)
                    : null,
                mailing_type: this.mailingType
            };

            formattedNewIntervener.otp_verification = this.otpVerification;
            formattedNewIntervener.document_id = this.personalData.document_id;
            formattedNewIntervener.uuid_distributor = this.account.uuid_distributor;
            formattedNewIntervener.uuid_subdistributor = this.account.uuid_subdistributor;
            formattedNewIntervener.is_new_intervener = true;
            formattedNewIntervener.representative_order = this.representativeOrder;

            formattedNewIntervener.source = 'AREA-PRIVADA';
            formattedNewIntervener.uuid_user_requestor =
                UsersService.getIntervenerFromLocalStore()?.uuid || null;

            return formattedNewIntervener;
        },

        roleHasBeenSelected() {
            return this.account_intervener_role ? this.account_intervener_role.length > 0 : false;
        },
        /**
         * Get the next representative order for the new intervener
         * @returns {number} The next representative order for the new intervener
         */
        representativeOrder() {
            let maxRepresentativeOrder = 0;

            if (this.intervenersList) {
                this.intervenersList.forEach(intervener => {
                    if (!intervener.account_intervener_role) return;

                    const hasRepresentativeRole = intervener.account_intervener_role.some(role =>
                        roles.REPRESENTATIVE_ROLES.includes(role.key.toUpperCase())
                    );

                    if (hasRepresentativeRole && intervener.representative_order != null) {
                        maxRepresentativeOrder = Math.max(
                            maxRepresentativeOrder,
                            intervener.representative_order
                        );
                    }
                });
            }

            return maxRepresentativeOrder + 1;
        },
        isApoderado() {
            return (
                this.account_intervener_role &&
                this.account_intervener_role.map(role => role.key).includes('APODERADO')
            );
        },
        juridicalIntervenerCif() {
            return this.juridicalIntervener?.document_id;
        },
        juridicalIntervenerUuid() {
            return this.juridicalIntervener?.uuid;
        },
        juridicalIntervener() {
            return (
                this.interveners &&
                this.interveners.find(intervener => intervener.document_type === 'CIF')
            );
        },
        availableRoleTypes() {
            const others = JSON.parse(JSON.stringify(this.intervenersList));
            const meTemp = {
                account_intervener_role: this.account_intervener_role
                    ? this.account_intervener_role
                    : [],
                birthdate: this.personalData.birthdate,
                intervener_type: this.accountType
            };
            let roles = [];

            roles = canRoles(this.accountType, others, meTemp).filter(
                rol => rol !== 'TITULAR' && rol !== 'NUDO_PROPIETARIO'
            );

            return mappingRoles(roles, this.roles);
        },

        needsReversoDocument() {
            if (!this.personalData.document_type) {
                return false;
            }
            return this.personalData.document_type.key === 'DNI';
        },
        isOptionalDocument() {
            if (!this.personalData.document_type) {
                return false;
            }
            return this.personalData.document_type.key !== 'DNI';
        },
        incompletePersonalDocument() {
            const frontFileMissing = !this.selectedFrontFile;

            const backFileMissing = this.needsReversoDocument && !this.selectedBackFile;

            const invalidDocument = this.showInvalidDocumentFormat || this.showInvalidDocumentSize;

            // returns if the document is incomplete or has errors.
            return frontFileMissing || backFileMissing || invalidDocument;
        },

        countries() {
            return this.countriesOptions;
        },

        loggedFullName() {
            if (this.loginStep > 1) {
                return `${this.logedIntervenerData.name} ${this.logedIntervenerData.lastname_1} ${
                    this.logedIntervenerData.lastname_2 ? this.logedIntervenerData.lastname_2 : ''
                }`;
            }
        },

        isDocumentIdDuplicate() {
            if (!this.personalData.document_id) return false;

            return this.isIntervenerDuplicate(this.personalData.document_id);
        }
    }
};
